import { Check } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';
import React from 'react';

const ConfiguredMark: React.FC = () => (
	<Stack
		data-testid="configured-mark"
		direction="row"
		alignItems="center"
		gap={0.5}
	>
		<Check color="primary" />
		<Typography>{intl.tr('general.configured')}</Typography>
	</Stack>
);

export default ConfiguredMark;
